import { Http } from '../../../support';
import Storage from '../../../support/Storage';

class HidroYPetroCatalogoManager {
  static __values = {};

  static async boot() {
    let value = await Storage.get('catalogo.hidroypetro');

    const params = {
      name: 'c_hyp',
      version: !!value ? value.version : '0',
    };

    let response = {};

    try {
      response = await Http.get('/api/catalogos/grupos', { params });
    } catch (error) {
      console.error(error);
    }

    if (!!response.data && response.data.length > 0) {
      value = {
        version: response.data[0].version,
        data: response.data,
      };

      await Storage.put('catalogo.hidroypetro', value);
    }

    if (!!value) {
      for (const item of value.data) {
        HidroYPetroCatalogoManager.__values[item.name] = item.values;
      }
    } else {
      throw new Error('Los catálogos de HidroYPetro no están disponibles');
    }
  }

  static async refresh() {
    await Storage.remove('catalogo.hidroypetro');

    await HidroYPetroCatalogoManager.boot();
  }

  static async reboot(catalog) {
    if (HidroYPetroCatalogoManager.__values) {
      let value = (await Storage.get('catalogo.hidroypetro')) || { version: '0', data: [] };

      for (const item of value.data) {
        HidroYPetroCatalogoManager.__values[item.name] = item.values;
      }
    }
  }

  static async get(catalog, _default = null) {
    if (HidroYPetroCatalogoManager.__values) {
      let value = (await Storage.get('catalogo.hidroypetro')) || { version: '0', data: [] };

      for (const item of value.data) {
        HidroYPetroCatalogoManager.__values[item.name] = item.values;
      }
    }

    return HidroYPetroCatalogoManager.__values[catalog] || _default;
  }

  static all() {
    return HidroYPetroCatalogoManager.__values;
  }
}

export default HidroYPetroCatalogoManager;
